export default {
  title: 'Informações',
  sections: {
    work_schedule: 'Horário: Encomendas online',
    delivery_schedule: 'Horários de entrega',
    delivery_costs: 'Custos de entrega',
    website: 'Website',
  },
  labels: {
    delivery_fees: 'Valor mín. - {{threshold}}, Taxa - {{fee}}',
  },
};
